







import { Component, Vue } from 'vue-property-decorator'
import BtnSquare from '@/components/Utils/form/button/BtnSquare.vue'
import InputText from '@/components/Utils/form/text/InputText.vue'

@Component({
  components: {
    BtnSquare,
    InputText
  }
})
export default class ChatForm extends Vue {
    text = '';

    send () {
      if (this.isEmpty) {
        return
      }

      this.$emit('submit', this.text)
      this.text = ''
    }

    get isEmpty () {
      return !this.text.match(/[^\x20\u3000]/)
    }
}
